/* unplugin-vue-components disabled */import { render } from "./CameraPermissionsNeeded.vue?vue&type=template&id=6c86f8a7&scoped=true"
import script from "./CameraPermissionsNeeded.vue?vue&type=script&lang=js"
export * from "./CameraPermissionsNeeded.vue?vue&type=script&lang=js"

import "./CameraPermissionsNeeded.vue?vue&type=style&index=0&id=6c86f8a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c86f8a7"]])

export default __exports__